<template>
  <van-popup v-model="isShowComment" position="right" :get-container="getContainer" class="comment_box">
    <div class="comment_container">
      <div class="comment_operate">
        <Icon iconClass="close" @click="closeComment()" />
      </div>
      <div class="labelbar">评论</div>
      <ul class="comment_list" v-if="!!commentList && commentList.length > 0">
        <li class="item" v-for="item in commentList" :key="item.id">
          <div class="comment_title">
            <div class="portrait" :style="{backgroundImage:'url(' +(item.memberImg == ''? require('@/assets/images/user_default.png'): item.memberImg) +')'}">
              <img :class="'pos'+item.identityInfo.topLeftResourceId" :src="item.identityInfo.bottomResourceUrl" v-if="!!item.identityInfo && JSON.stringify(item.identityInfo) != '{}'" />
            </div>
            <div class="text">
              <div class="nick">{{ item.memberName }}</div>
              <div class="time">{{ item.createdTime }}</div>
            </div>
            <div class="button_con">
              <button class="reply_btn" @click="replyComment(item.id)">
                回复
              </button>
            </div>
            <div class="button_con">
              <button class="praise_btn" @click="onClickCommentPraise($event, item)">
                <Icon iconClass="praise-o" />
                <Icon iconClass="praise" /><span v-text="item.topCount"></span>
              </button>
            </div>
          </div>
          <div class="comment_content">
            <div class="comm_cont" v-html="item.comment"></div>
            <div class="sub_comm" v-if="item.replyCount > 0">
              <ul class="sub_comm_list">
                <li class="sub_comm_item" v-for="subItem in item.childArray" :key="subItem.id">
                  <span class="username">{{ subItem.memberName }}：</span>
                  <span class="usercomm">{{ subItem.comment }}</span>
                </li>
                <li class="sub_comm_item" v-if="item.replyCount > 2 && item.childArray.length <= 2">
                  <span class="sub_comm_more" @click="onClickCommentMoreReply(item)" v-if="item.replyCount <= 10">查看全部{{ item.replyCount }}条回复></span>
                  <span class="sub_comm_more" @click="onClickCommentMoreReply(item)" v-else>查看更多回复></span>
                </li>
                <li class="sub_comm_item" v-else-if="
                    item.replyCount > 2 &&
                    item.childArray.length > 2 &&
                    item.replyCount > item.childArray.length
                  ">
                  <span class="sub_comm_more" @click="onClickCommentMoreReply(item)">查看更多回复></span>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <ul class="comment_status" v-if="!!commentList && commentList.length > 0">
        <li class="more" v-if="!commentLoadOver">
          <div class="more_all" @click="loadMoreComment">点击查看更多</div>
        </li>
        <li class="more" v-else>
          <div class="more_all">暂无更多评论</div>
        </li>
      </ul>
      <ul class="comment_status" v-else>
        <li class="more">
          <div class="nodata"></div>
          <div>快来抢沙发</div>
        </li>
      </ul>
    </div>
  </van-popup>
</template>
<script>
import { mapState } from "vuex";
import commApi from "@/api/apis/common.js";
export default {
  name: "Comment",
  props: {
    params: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("app", ["userInfo"]),
  },
  data() {
    return {
      /* 是否显示评论弹层 */
      isShowComment: false,
      commentLoadOver: false,
      commentList: [],
      commentTotal: 0,
      commentPage: 0,
    };
  },
  watch: {
    params: {
      handler(newValue, oldVue) {
        if (
          Object.prototype.hasOwnProperty.call(newValue, "contentId") &&
          Object.prototype.hasOwnProperty.call(newValue, "type")
        ) {
          const obj = {
            orderFlag: 0,
            pageNo: 0,
            pageSize: 10,
            parentId: 0,
          };
          this.params = Object.assign(this.params, obj);
          this.getCommentListByNewsId();
        }
      },
      deep: true,
    },
    show: {
      handler(newValue, oldValue) {
        this.isShowComment = newValue;
        if (this.isShowComment) {
          this.params.pageNo = 0;
          this.commentLoadOver = false;
          this.commentList = [];
          this.commentTotal = 0;
          this.commentPage = 0;
          this.getCommentListByNewsId();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      return document.querySelector(".gallery_detail_container");
    },
    /* 获取评论 */
    getCommentListByNewsId() {
      var _this = this;
      commApi
        .getCommentListByNewsId(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.commentList = res.data.commentList;
            } else {
              _this.commentList = _this.commentList.concat(
                res.data.commentList
              );
            }
            _this.commentTotal = res.data.totalComment;

            _this.commentPage = Math.ceil(
              res.data.totalComment / _this.params.pageSize
            );
            if (_this.params.pageNo >= _this.commentPage - 1) {
              _this.commentLoadOver = true;
            } else {
              _this.commentLoadOver = false;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 点击加载更多评论 */
    loadMoreComment() {
      this.params.pageNo++;
      this.getCommentListByNewsId();
    },
    /* 获取评论回复 */
    getCommentReply(item) {
      var _this = this;
      commApi
        .getCommentListByNewsId(item.replayParams)
        .then((res) => {
          if (res.suc == 1) {
            if (item.replayParams.pageNo == 0) {
              item.childArray = res.data.commentList;
            } else {
              item.childArray = item.childArray.concat(res.data.commentList);
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 查看更多回复 */
    onClickCommentMoreReply(item) {
      if (!!item.replayParams) {
        item.replayParams.pageNo++;
        this.getCommentReply(item);
      } else {
        item.replayParams = {
          pageNo: 0,
          pageSize: 10,
          contentId: this.params.contentId,
          type: this.params.type,
          parentId: item.id,
          commentId: item.id,
        };
        this.getCommentReply(item);
      }
    },
    /* 评论点赞/取消点赞 */
    onClickCommentPraise(event, item) {
      let target = event.currentTarget;
      let clsArray = target.classList;
      if (!clsArray.contains("praised")) {
        var params = {
          commentId: item.id,
        };
        commApi
          .giveThumbsUpComment(params)
          .then((res) => {
            if (res.suc == 1) {
              target.classList.add("praised");
              item.topCount++;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 关闭评论列表 */
    closeComment() {
      this.$emit("closeComment", true);
    },
    /* 回复 */
    replyComment(commentId) {
      if (!!this.userInfo) {
        this.$emit("replyForm", commentId);
      } else {
        this.$router.push("/login");
      }
    },
  },
  created() {
    this.isShowComment = this.show;
  },
  mounted() {
    if (
      Object.prototype.hasOwnProperty.call(this.params, "contentId") &&
      Object.prototype.hasOwnProperty.call(this.params, "type")
    ) {
      const obj = {
        orderFlag: 0,
        pageNo: 0,
        pageSize: 10,
        parentId: 0,
      };
      this.params = Object.assign(this.params, obj);
      if (this.isShowComment) {
        this.getCommentListByNewsId();
      }
    }
  },
};
</script>

<style lang='scss' scoped>
.comment_box {
  .comment_container {
    position: relative;
    .comment_operate {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      .tj-svg-icon {
        vertical-align: top;
      }
    }
    .labelbar {
      position: relative;
      width: 100%;
      line-height: 20px;
      padding: 15px 10px 10px;
      border-bottom: 1px solid #eeeef0;
      color: #323232;
      font-size: 15px;
      font-weight: bold;
      &::before {
        position: absolute;
        left: 0;
        top: 17px;
        display: block;
        width: 4px;
        height: 16px;
        background-color: #318bff;
        content: "";
        border-radius: 2px;
      }
    }
    .comment_list {
      width: 100%;
      .item {
        padding: 15px 0;
        border-bottom: 1px solid #efefef;
        &:last-child {
          border-bottom: none;
        }
        .comment_title {
          display: flex;
          .portrait {
            position: relative;
            max-width: 32px;
            min-width: 32px;
            height: 32px;
            border: 1px solid #fff;
            border-radius: 16px;
            -webkit-border-radius: 16px;
            -moz-border-radius: 16px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            img {
              position: absolute;
              &.pos1 {
                left: -4px;
                top: -4px;
                width: 16px;
                height: 16px;
              }
              &.pos2 {
                right: -4px;
                top: -4px;
                width: 16px;
                height: 16px;
              }
              &.pos3 {
                left: -4px;
                bottom: -4px;
                width: 16px;
                height: 16px;
              }
              &.pos4 {
                left: 50%;
                bottom: -8px;
                width: auto;
                height: 16px;
                transform: translateX(-50%);
              }
              &.pos5 {
                right: -4px;
                bottom: -4px;
                width: 16px;
                height: 16px;
              }
            }
          }
          .text {
            width: 100%;
            padding: 0 8px 0 12px;
            overflow: hidden;
            .nick {
              color: #001f6f;
              font-size: 14px;
              font-weight: bolder;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              line-height: 16px;
            }
            .time {
              color: #a1a1a1;
              font-size: 10px;
              line-height: 20px;
              margin-top: 3px;
            }
          }
          .button_con {
            text-align: right;
            .reply_btn {
              width: 30px;
              padding: 0;
              margin-right: 15px;
              color: #a1a1a1;
              font-size: 12px;
              background-color: transparent;
              border: none;
              outline: none;
            }
            .praise_btn {
              background: none;
              color: #a1a1a1;
              font-size: 12px;
              border: none;
              outline: none;
              white-space: nowrap;
              .tj-svg-icon {
                margin-right: 3px;
                font-size: 16px;
                vertical-align: -2.4px;
                &.tj-icon-praise {
                  display: none;
                }
              }
              &.praised {
                color: #318bff;
                .tj-svg-icon {
                  &.tj-icon-praise {
                    display: inline;
                  }
                  &.tj-icon-praise-o {
                    display: none;
                  }
                }
              }
            }
          }
        }
        .comment_content {
          line-height: 24px;
          padding-left: 40px;
          margin-top: 5px;
          color: #1a1a1a;
          .comm_cont {
            padding-bottom: 5px;
          }
          .sub_comm {
            width: 100%;
            background: #efefef;
            .sub_comm_list {
              padding: 8px;
              .sub_comm_item {
                margin: 0;
                padding: 0;
                font-size: 13px;
                .username,
                .sub_comm_more {
                  color: #3d64a7;
                }
              }
            }
          }
        }
      }
    }
    .comment_status {
      padding-top: 8px;
      padding-bottom: 5px;
      text-align: center;
      .nodata {
        width: 100%;
        height: 100px;
        background-image: url(~@/assets/images/no_data.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: auto 80px;
      }
      .more {
        display: inline;
        line-height: 24px;
        color: #1a1a1a;
        font-size: 14px;
      }
    }
  }
}
</style>